import React from 'react';
import { Container, Temperature, TemperatureValue, TimeDisplay, WeatherIcon } from './styles';
import CachedImg from 'components/common/CachedImg/CachedImg';
/**
 * TV-Optimized Weather Widget
 * Displays temperature and time with minimal CSS overhead
 */
export default function WeatherWidget({ weather, time }) {
  return (
    <Container>
      {weather?.icon && (
        <WeatherIcon>
          <CachedImg src={'http://openweathermap.org/img/wn/' + weather.icon + '.png'} />
        </WeatherIcon>
      )}
      {weather?.temp && (
        <Temperature>
          <TemperatureValue>{weather.temp}°C</TemperatureValue>
        </Temperature>
      )}
      <TimeDisplay>{time || '--:--'}</TimeDisplay>
    </Container>
  );
}
